module.exports = __webpack_public_path__ + "img/line-dashed.98e05f6f.svg";